// extracted by mini-css-extract-plugin
module.exports = {"infoBadge":"PasswordForm_infoBadge__10ndU"};